import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const USERS = {
  'op001': { password: 'verichain2024', role: 'operator', name: 'Operator 001', email: 'operator@verichain.co.za' },
  'mgr001': { password: 'verichain2024', role: 'manager', name: 'Manager 001', email: 'manager@verichain.co.za' },
};

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    setTimeout(() => {
      const user = USERS[username.trim().toLowerCase()];
      if (user && user.password === password.trim()) {
        localStorage.setItem('verichain_user', user.name);
        localStorage.setItem('verichain_username', username.trim().toLowerCase());
        localStorage.setItem('verichain_role', user.role);
        localStorage.setItem('verichain_email', user.email);
        navigate('/dashboard');
      } else {
        setError('Invalid username or password');
        setLoading(false);
      }
    }, 800);
  };

  return (
    <div className="page" style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
    }}>
      <div className="card" style={{ width: '100%', maxWidth: '420px' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h1 style={{
            fontSize: '36px',
            fontWeight: 'bold',
            color: '#FFFFFF',
            letterSpacing: '4px',
          }}>
            FALCON
          </h1>
          <p style={{
            color: '#C9920A',
            fontSize: '11px',
            fontStyle: 'italic',
            marginTop: '4px',
            letterSpacing: '2px',
          }}>
            by VERICHAIN
          </p>
          <p style={{
            color: '#64748B',
            fontSize: '12px',
            marginTop: '8px',
          }}>
            Manufacturer Intelligence Portal
          </p>
        </div>

        {/* Divider */}
        <div style={{
          height: '2px',
          background: 'linear-gradient(135deg, #f9bc3d, #c28c00)',
          marginBottom: '24px',
          borderRadius: '1px',
        }} />

        {/* Loading state */}
        {loading ? (
          <div style={{ textAlign: 'center', padding: '32px 0' }}>
            <div style={{
              width: '40px',
              height: '40px',
              border: '3px solid #1E3A6E',
              borderTop: '3px solid #C9920A',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite',
              margin: '0 auto 16px',
            }} />
            <p style={{ color: '#C9920A', fontSize: '13px' }}>
              Signing in to Falcon...
            </p>
          </div>
        ) : (
          <form onSubmit={handleLogin}>
            <label className="label">Username</label>
            <input
              className="input"
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />

            <label className="label">Password</label>
            <input
              className="input"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            {error && <p className="error">{error}</p>}

            <button className="btn-primary" type="submit">
              Sign In to Falcon
            </button>
          </form>
        )}

        {/* Footer */}
        <p style={{
          textAlign: 'center',
          marginTop: '24px',
          fontSize: '11px',
          color: '#64748B',
        }}>
          Falcon v2.0 · Powered by Verichain
        </p>

      </div>
    </div>
  );
}

export default Login;